import { render, staticRenderFns } from "./sanalAsuulga.vue?vue&type=template&id=47f05ec3&"
import script from "./sanalAsuulga.vue?vue&type=script&lang=js&"
export * from "./sanalAsuulga.vue?vue&type=script&lang=js&"
import style0 from "./sanalAsuulga.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sanalAsuulga.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports